import { formatAndValidatePrice, formatPrice } from "utils/formatPrice"

export const mapSimulatedConsumption = (simulatedConsumption: App.ISimulatedConsumption, currency = "BRL") => {
  const priceBreakdownMap = simulatedConsumption?.priceBreakdown.map((price) => ({
    formatedPriceBySimulatedConsumption: formatPrice(price.priceBySimulatedConsumption, currency),
    formatedEventTypePrice: formatPrice(price.eventTypePrice, currency),
    isVisible: !!price.priceBySimulatedConsumption,
    label: price.eventTypeLabel
  }))

  return {
    priceBreakdown: priceBreakdownMap,
    defaultConsumptionMultiplier: simulatedConsumption?.consumptionSimulationMultiplier,
    totalPrice: formatAndValidatePrice(simulatedConsumption?.totalPrice.toString() ?? "0", currency)
  }
}

export const mapSimulatedDevModeBreakdown = (simulatedDevModeBreakdown: App.ISimulatedBreakdown, currency = "BRL") => {
  const priceBreakdownMap = simulatedDevModeBreakdown?.priceBreakdown?.map((breakdown) => ({
    price: formatPrice(breakdown?.price ?? 0, currency),
    label: breakdown?.label ?? "",
    unit: breakdown?.unit ?? "",
    count: breakdown?.count ?? "",
    totalPrice: formatPrice(breakdown?.totalPrice ?? 0, currency)
  }))

  return {
    priceBreakdown: priceBreakdownMap,
    totalPrice: formatPrice(simulatedDevModeBreakdown?.totalPrice ?? 0, currency)
  }
}

export const mapSimulatedMonthly = (price: number, currency = "BRL") => {
  return formatPrice(price, currency)
}
